/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  FETCH_PLAYERS: "[Players] Fetch players",
  FETCH_PLAYERS_SUCCESS: "[Players] Fetch players success",
  FETCH_PLAYERS_FAILED: "[Players] Fetch players failed",

  FETCH_A_PLAYER: "[Players] Fetch a player",
  FETCH_A_PLAYER_SUCCESS: "[Players] Fetch a player success",
  FETCH_A_PLAYER_FAILED: "[Players] Fetch a player failed",

  FETCH_A_PLAYER_V3: "[Players] Fetch a player version 3",
  FETCH_A_PLAYER_V3_SUCCESS: "[Players] Fetch a player version 3 success",
  FETCH_A_PLAYER_V3_FAILED: "[Players] Fetch a player version 3 failed",

  FETCH_A_PLAYER_PUT_DATAPIPE: "[Players] Fetch a player put to datapipe",
  FETCH_A_PLAYER_PUT_DATAPIPE_SUCCESS:
    "[Players] Fetch a player put to datapipe",
  UPDATE_SELECTED_COMPANY_FOR_PLAYER:
    "[Players] Update Selected Company for Player",
  FETCH_PLAYER_LIST: "[Players] Fetch player list",
  FETCH_PLAYER_LIST_SUCCESS: "[Players] Fetch player list success",
  FETCH_PLAYER_LIST_FAILED: "[Players] Fetch splayer list failed",
  DELETE_PLAYER_ENTITIES: "[Players] Delete player entities",
  FETCH_PLAYER_FROM_DATAPIPE: "[Players] Fetch player from datapaipe success",
  REMOVE_PLAYER_ENTITIES: "[Players] Remove player entities",
  FETCH_A_PLAYER_PUT_DATAPIPE_V3_1:
    "[Players] Fetch a player put to datapipe v3.1",
  FETCH_A_PLAYER_PUT_DATAPIPE_V3_1_SUCCESS:
    "[Players] Fetch a player put to datapipe v3.1 success",
  INTIAL_PLAYER_ENTITIES: "[Players] Intial player entities",

  FETCH_PLAYER_RESTRICTION_LIST: "[Players] Fetch Player Restriction list",
  FETCH_PLAYER_RESTRICTION_LIST_SUCCESS:
    "[Players] Fetch Player Restriction list success",
  FETCH_PLAYER_RESTRICTION_LIST_FAILED:
    "[Players] Fetch Player Restriction list failed",
  CLEAR_PLAYER_RESTRICTION_LIST: "[Players] Clear Player Restriction list",
  CLEAR_PLAYER_LIST: "[Players] Clear Player list",
  CREATE_PLAYER_RESTRICTION: "[Players] Create Player Restriction",
  CREATE_PLAYER_RESTRICTION_SUCCESS:
    "[Players] Create Player Restriction success",
  CREATE_PLAYER_RESTRICTION_FAILED:
    "[Players] Create Player Restriction failed",
  DELETE_PLAYER_RESTRICTION: "[Players] Delete Player Restriction",
  DELETE_PLAYER_RESTRICTION_SUCCESS:
    "[Players] Delete Player Restriction success",
  DELETE_PLAYER_RESTRICTION_FAILED:
    "[Players] Delete Player Restriction failed",
};
//
// ─── FETCH PLAYER ACTIONS ────────────────────────────────────────────────────
//

export const FetchPlayer = (customerCode) => ({
  type: types.FETCH_PLAYERS,
  payload: customerCode,
});
export const FetchPlayersSuccess = (list) => ({
  type: types.FETCH_PLAYERS_SUCCESS,
  payload: list,
});
export const FetchPlayersFailed = (error) => ({
  type: types.FETCH_PLAYERS_FAILED,
  payload: error,
});
//
// ─── FETCH A PLAYER ACTIONS ────────────────────────────────────────────────────
//

export const FetchAPlayer = (id) => ({
  type: types.FETCH_A_PLAYER,
  payload: id,
});

export const FetchAPlayerSuccess = (list) => ({
  type: types.FETCH_A_PLAYER_SUCCESS,
  payload: list,
});

export const FetchAPlayerFailed = (error) => ({
  type: types.FETCH_A_PLAYER_FAILED,
  payload: error,
});
//
// ─── FETCH A PLAYER PUT TO DATAPIPE ACTIONS ────────────────────────────────────────────────────
//

export const FetchAPlayerPutToDatapipe = (data, roleName) => ({
  type: types.FETCH_A_PLAYER_PUT_DATAPIPE,
  payload: { data, roleName },
});

export const FetchAPlayerPutToDatapipeFailed = (error) => ({
  type: types.FETCH_A_PLAYER_PUT_DATAPIPE_FAILED,
  payload: error,
});
//
// ─── UPDATE SELECTED COMPANY FOR PLAYER───────────────────────────────────────────────────
//
export const UpdateSelectedCompanyForPlayer = (data) => ({
  type: types.UPDATE_SELECTED_COMPANY_FOR_PLAYER,
  payload: data,
});

export const FetchPlayerList = (status, id) => ({
  type: types.FETCH_PLAYER_LIST,
  payload: {
    status,
    id,
  },
});

export const FetchPlayerLIstSuccess = (list) => ({
  type: types.FETCH_PLAYER_LIST_SUCCESS,
  payload: list,
});

export const FetchPlayerListFailed = (error) => ({
  type: types.FETCH_PLAYER_LIST_FAILED,
  payload: error,
});
export const FetchAPlayerV3 = (id, roleName) => ({
  type: types.FETCH_A_PLAYER_V3,
  payload: { id, roleName },
});

export const FetchAPlayerV3Success = (list) => ({
  type: types.FETCH_A_PLAYER_V3_SUCCESS,
  payload: list,
});

export const FetchAPlayerV3Failed = (error) => ({
  type: types.FETCH_A_PLAYER_V3_FAILED,
  payload: error,
});
export const DeletePlayerEntities = () => ({
  type: types.DELETE_PLAYER_ENTITIES,
});
export const FetchPlayerFromDatapipeSuccess = (list) => ({
  type: types.FETCH_PLAYER_FROM_DATAPIPE,
  payload: list,
});
export const RemovePlayerEntities = (id) => ({
  type: types.REMOVE_PLAYER_ENTITIES,
  payload: id,
});

export const FetchAPlayerPutToDatapipeV3_1 = (data, roleName) => ({
  type: types.FETCH_A_PLAYER_PUT_DATAPIPE_V3_1,
  payload: { data, roleName },
});
export const IntialPlayerEntities = (data) => ({
  type: types.INTIAL_PLAYER_ENTITIES,
  payload: data,
});

export const FetchPlayerRestrictionList = (id) => ({
  type: types.FETCH_PLAYER_RESTRICTION_LIST,
  payload: id,
});

export const FetchPlayerRestrictionListSuccess = (list) => ({
  type: types.FETCH_PLAYER_RESTRICTION_LIST_SUCCESS,
  payload: list,
});

export const FetchPlayerRestrictionListFailed = (error) => ({
  type: types.FETCH_PLAYER_RESTRICTION_LIST_FAILED,
  payload: error,
});
export const ClearPlayerRestrictionList = () => ({
  type: types.CLEAR_PLAYER_RESTRICTION_LIST,
});
export const ClearPlayerList = () => ({
  type: types.CLEAR_PLAYER_LIST,
});
export const CreatePlayerRestriction = (data) => ({
  type: types.CREATE_PLAYER_RESTRICTION,
  payload: data,
});
export const CreatePlayerRestrictionSuccess = (response) => ({
  type: types.CREATE_PLAYER_RESTRICTION_SUCCESS,
  payload: response,
});
export const CreatePlayerRestrictionFailed = (error) => ({
  type: types.CREATE_PLAYER_RESTRICTION_FAILED,
  payload: error,
});
export const DeletePlayerRestriction = (id) => ({
  type: types.DELETE_PLAYER_RESTRICTION,
  payload: id,
});
export const DeletePlayerRestrictionSuccess = (response) => ({
  type: types.DELETE_PLAYER_RESTRICTION_SUCCESS,
  payload: response,
});
export const DeletePlayerRestrictionFailed = (response) => ({
  type: types.DELETE_PLAYER_RESTRICTION_FAILED,
  payload: response,
});
